import React, { useRef } from "react";
import { Layout, Button } from "antd";
import { ImageUrl } from "../../helpers/Functions";
import { useNavigate } from "react-router";
import { FaArrowRight, FaPlay } from "react-icons/fa";
import {
  HiOutlineBuildingLibrary,
  HiOutlineChartBar,
  HiOutlineDocumentText,
  HiOutlineAcademicCap,
  HiOutlineUserGroup,
  HiOutlinePresentationChartLine,
  HiOutlineUser,
  HiOutlineUsers,
} from "react-icons/hi2";
import "./courses-page.css";

const items = [
  {
    title: "B2B Training",
    image: "new-51.png",
    link: "/b2bTraining",
    desc: "Custom workforce training programs designed for organizations and enterprise teams.",
    icon: HiOutlineUsers,
  },
  {
    title: "Course Integration API",
    image: "new-45.png",
    link: "/courceintegrationAPi",
    desc: "Seamlessly connect WrightCo courses with your LMS, Zoom, and ecommerce tools.",
    icon: HiOutlineBuildingLibrary,
  },
  {
    title: "Customer Stories",
    image: "new-90.png",
    link: "/CustomerStories",
    desc: "Real outcomes from educators and partners who elevated their learning programs.",
    icon: HiOutlineDocumentText,
  },
  {
    title: "Customer Training",
    image: "new-56.png",
    link: "/customerTraining",
    desc: "Engage your customers with branded, ready-to-deliver training experiences.",
    icon: HiOutlineAcademicCap,
  },
  {
    title: "Employee Development",
    image: "new-78.png",
    link: "/employeeDevelopment",
    desc: "Grow staff skills with structured pathways for early care and education teams.",
    icon: HiOutlineUserGroup,
  },
  {
    title: "Flexible Ecommerce",
    image: "new-22.png",
    link: "/flexibleEcommerce",
    desc: "Sell courses and enrollments with flexible checkout and catalog options.",
    icon: HiOutlinePresentationChartLine,
  },
  {
    title: "Instructor Led Training",
    image: "new-10.png",
    link: "/instructorLedTraining",
    desc: "Live virtual classrooms led by expert instructors for high-impact learning.",
    icon: HiOutlineUser,
  },
  {
    title: "Learner Reports",
    image: "new-18.png",
    link: "/learnerReports",
    desc: "Track progress, completion, and performance with clear learner dashboards.",
    icon: HiOutlineChartBar,
  },
];

function Courses() {
  const navigate = useNavigate();
  const gridRef = useRef(null);

  const scrollToServices = () => {
    gridRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <Layout className="courses-page">
      <section
        className="courses-hero"
        style={{ backgroundImage: `url(${ImageUrl("service-banner-new.png")})` }}
      >
        <div className="courses-hero-overlay" aria-hidden />
        <div className="courses-wrap courses-hero-inner">
          <div className="courses-hero-copy">
            <span className="courses-hero-badge">WRIGHTCO ACADEMY</span>
            <h1 className="fontFamily1 courses-hero-title">
              Empowering Educators.
              <span> Inspiring Change.</span>
            </h1>
            <p className="fontFamily1 courses-hero-sub">
              Expert-led services and training solutions to elevate early care and
              education.
            </p>
            <div className="courses-hero-actions">
              <Button
                type="primary"
                size="large"
                className="courses-hero-btn-primary"
                onClick={() => navigate("/signup")}
              >
                Get Started <FaArrowRight />
              </Button>
              <Button
                size="large"
                className="courses-hero-btn-outline"
                onClick={scrollToServices}
              >
                <FaPlay /> Explore Services
              </Button>
            </div>
          </div>
        </div>
      </section>

      <div className="courses-wrap courses-main" ref={gridRef}>
        <div className="courses-grid">
          {items.map((item) => {
            const Icon = item.icon;
            return (
              <article key={item.link} className="courses-card">
                <div className="courses-card-media">
                  <img src={ImageUrl(item.image)} alt="" loading="lazy" />
                  <span className="courses-card-icon" aria-hidden>
                    <Icon />
                  </span>
                </div>
                <div className="courses-card-body">
                  <h3 className="fontFamily1">{item.title}</h3>
                  <p className="fontFamily1">{item.desc}</p>
                  <button
                    type="button"
                    className="courses-card-cta"
                    onClick={() => navigate(item.link)}
                  >
                    View Details <FaArrowRight />
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </Layout>
  );
}

export default Courses;
